export const events = {
  PERFORMANCE_INCLINE: "PERFORMANCE_INCLINE",
  PERFORMANCE_DECLINE: "PERFORMANCE_DECLINE",

  LOADING_START: "LOADING_START",
  LOADING_PROGRESS: "LOADING_PROGRESS",
  // When assets are loaded
  LOADING_COMPLETE: "LOADING_COMPLETE",
  // When loader can animate out
  LOADING_DONE: "LOADING_DONE",

  ROUTE_CHANGE_START: "ROUTE_CHANGE_START",
  ROUTE_CHANGE_COMPLETE: "ROUTE_CHANGE_COMPLETE",

  CHANGE_DOCUMENT_CURSOR: "CHANGE_DOCUMENT_CURSOR",
};
